import { createAsyncActions } from '@wahaaabello/redux-async-actions';

const [
  fetchUserActivitiesRequest,
  fetchUserActivitiesSuccess,
  fetchUserActivitiesFailure
] = createAsyncActions('FETCH_USER_ACTIVITIES');

const [
  fetchUserTodosRequest,
  fetchUserTodosSuccess,
  fetchUserTodosFailure
] = createAsyncActions('FETCH_USER_TODOS');

const [
  fetchUserTransactionsRequest,
  fetchUserTransactionsSuccess,
  fetchUserTransactionsFailure
] = createAsyncActions('FETCH_USER_TRANSACTIONS');

const userActions = {
  fetchUserActivitiesRequest,
  fetchUserActivitiesSuccess,
  fetchUserActivitiesFailure,
  fetchUserTodosRequest,
  fetchUserTodosSuccess,
  fetchUserTodosFailure,
  fetchUserTransactionsRequest,
  fetchUserTransactionsSuccess,
  fetchUserTransactionsFailure
};

export default userActions;
